import { render, staticRenderFns } from "./SubgroupLayout.vue?vue&type=template&id=0fdccd5f"
import script from "./SubgroupLayout.vue?vue&type=script&lang=js"
export * from "./SubgroupLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports